import axios, { AxiosInstance } from "axios"
import { environment } from "@/environments/environment"
import router from "@/router";
import store from "@/store";
import {loginAndRedirect} from "@/api/authorisation";

export const instance: AxiosInstance = axios.create({
	baseURL: `${environment.API_CLIENT}`
})

instance.interceptors.response.use(
		(response) => response,
		async (error) => {
			const status = error.response?.status

			if (!error.response && !axios.isCancel(error)) {
				console.log('**** interceptors - no connection / network error')
				await router.push({name: 'no-connection'})
			} else if (status === 401) {
				console.log('Access denied - invalid credentials - login required')
				loginAndRedirect()
			} else if (status === 403) {
				console.log('Access denied - redirect to home')
				const appRootUrl = store.getters['configModule/appRootUrl']
				console.log('Reload app ' + appRootUrl)
				window.location.href = appRootUrl
			} else if (status === 404) {
				console.log('**** interceptors route to expired-or-not-found')
				await router.push({ name: 'expired-or-not-found' })
			} else {
				console.log('**** interceptors route to server-error')
				await router.push({ name: 'server-error' })
			}

			return Promise.reject(error)
		}
)